import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Chancellery
 */
@Entity()
export class Chancellery extends Partner {
  static override _class = 'Chancellery';

  override get type() {
    return KooperationsPartner.CHANCELLERY;
  }
}
